import React from 'react';

const BrandLogo = ({ className = '' }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <span className="text-[#005b9f] font-bold text-xl tracking-wide uppercase whitespace-nowrap">
        Deutscher Reisering
      </span>
    </div>
  );
};

export default BrandLogo;